import React, { Component } from 'react';
import { Translate } from '$common';



export default class PhoneNumber extends Component {
  static type = 'phone_number';
  static elementName = Translate.get('phone');
  static icon = 'phone';

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/task-form/question-types/phone-number.js